import supportedLanguages from "./supportedLanguages.json";

const jsonFiles = import.meta.glob("./*.json", { import: "default", eager: true });

const localizedResources = supportedLanguages.reduce<{ [key: string]: any }>((acc, curr) => {
  const messages: any = jsonFiles[`./${curr}.json`];
  acc[curr] = messages;
  return acc;
}, {});

export default localizedResources;
